export default {
  getCountryDataStatus: {
    loading: false,
    error: false,
    data: null,
  },
  getCurrenciesDataStatus: {
    loading: false,
    error: false,
    data: null,
  },
};
